import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '@tsin-core/services/language.service';

@Component({
  selector: 'app-welcome',
  standalone: true,
  imports: [ButtonModule, RouterModule, TranslateModule],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss'
})
export class WelcomeComponent {
  private languageService = inject(LanguageService);
  private router = inject(Router);

  /** Reflects the language set by the route guard (EN for /welcome, FR for /fr/welcome). */
  currentLang = this.languageService.current;

  /** Navigate to the language-versioned welcome URL so the route guard fires and
   *  the translate pipe re-renders on a fresh component mount. */
  setLanguage(lang: 'en' | 'fr'): void {
    if (lang === 'fr') {
      this.router.navigate(['/fr/welcome']);
    } else {
      this.router.navigate(['/welcome']);
    }
  }
}
